import { Mocker, makeMocker } from "./mock-common";
import { CandidateInfo } from "../api-types/cds-api";

export const mockCDSResponse: Mocker<CandidateInfo> = makeMocker<CandidateInfo>({
  candidateId: "253c57c0-152c-11ee-b39d-e9573de9bcbd",
  candidateGlobalId: "CIDNA4900016241",
  sfCandidateId: undefined,
});
